import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { NotificationContainer } from 'Components/ReactNotifications';
import AppLocale from '../lang';
import MainRoute from 'Routes';
import { AccessDenied, NotFound } from '../components/CustomerStatus';
import 'Assets/css/vendor/bootstrap.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';

export function CustomerRoutes() {
    return (
        <Switch>
            <Route exact path="/" component={AccessDenied} />
            <Route exact path="/app" component={AccessDenied} />
            <Route exact path="/app/order/take/:AccessCode" render={props => (
                <MainRoute key={props.match.params.AccessCode} {...props} />
            )} />
            <Route component={NotFound} />
        </Switch>
    );
}

function App({ locale }) {
    const currentAppLocale = AppLocale[locale];
    return (
        <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
            <React.Fragment>
                <NotificationContainer />
                <CustomerRoutes />
            </React.Fragment>
        </IntlProvider>
    );
}

export default connect(({ settings }) => ({ locale: settings.locale }))(App);
